import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column align-content-center min-h-md-300px mh-500px scroll scroll-y" }
const _hoisted_2 = { class: "p-0 m-0" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "fs-6 mb-4" }
const _hoisted_5 = {
  key: 0,
  class: "fs-6 ms-auto"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  class: "mt-auto"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "fs-3 border-bottom mb-2 pb-2" }, "attachments", -1)
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file me-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalBase = _resolveComponent("ModalBase")!

  return (_openBlock(), _createBlock(_component_ModalBase, {
    title: "View Communication",
    ref: "modal",
    size: "modal-lg",
    "has-toolbar": false,
    "has-header": true,
    "is-loading": _ctx.isLoading,
    "loading-text": "Loading Communication"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.communication.title), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.getFriendlyDateTime(_ctx.communication.lastUpdated)), 1),
          (_ctx.communication.authorFirstName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, "by " + _toDisplayString(_ctx.communication.authorFirstName) + " " + _toDisplayString(_ctx.communication.authorLastName), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          innerHTML: _ctx.communication.content
        }, null, 8, _hoisted_6),
        (_ctx.communication.attachments && _ctx.communication.attachments.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.communication.attachments, (attachment) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: attachment.communicationAttachmentId
                }, [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (_ctx.getAttachmentLink(attachment.communicationAttachmentId)),
                    class: "text-hover-primary cursor-pointer fw-bold"
                  }, [
                    _hoisted_10,
                    _createTextVNode(" " + _toDisplayString(attachment.filename) + " (" + _toDisplayString(_ctx.convertToMB(attachment.size)) + ") ", 1)
                  ], 8, _hoisted_9)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["is-loading"]))
}